module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Speaker-de5fe478913748f28d4a87699d389f45.svg";